import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';

import {useBankAccounts} from '../hooks/useBankAccounts.ts';


interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

export const DeleteRecordButton = ({selectedIds, onDeleteComplete}: DeleteRecordButtonProps) => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    const {deleteRecords} = useBankAccounts(customerId);

    const disabled = selectedIds.length === 0;

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={selectedIds.length}
        handleConfirm={() => {
            deleteRecords(selectedIds);
            onDeleteComplete?.();
        }}/>);
};
